export class UniqueQueue<T> implements Iterable<T> {
    private items: T[];
    private readonly maxSize?: number;

    constructor(maxSize?: number, initialItems: T[] = []) {
        this.items = [];
        this.maxSize = maxSize;

        for (const item of initialItems) {
            this.enqueue(item);
        }
    }

    enqueue(item: T): void {
        this.items = this.items.filter((value) => value !== item);
        this.items.unshift(item);

        if (this.maxSize && this.items.length > this.maxSize) {
            this.items.pop();
        }
    }

    size(): number {
        return this.items.length;
    }

    values(): T[] {
        return [...this.items];
    }

    [Symbol.iterator](): Iterator<T> {
        let index = 0;

        return {
            next: (): IteratorResult<T> => {
                if (index < this.items.length) {
                    const value = this.items[index];
                    index++;
                    return { value, done: false };
                } else {
                    return { value: undefined, done: true };
                }
            },
        };
    }
}
